<template>
  <div class="well" style="padding: 3em;">

    <b-form @submit="onSubmit"  @reset="onReset" style="text-align:left;">

      <b-form-group id="input-group-2" label="輸入管理員密碼：" label-for="input-2"
        class="form_text">
        <b-form-input
          id="input-2"
          type="password"
          v-model="form.psWords"
          placeholder="輸入管理員密碼"
          :state="wordState" trim
          required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="輸入切換帳號：" label-for="input-1"
        class="form_text">
        <b-form-input
          id="input-3"
          type="text"
          v-model="form.userId"
          placeholder="請輸入帳號..."
          :state="wordState" trim
          required></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">切換&nbsp;<b-icon icon="check"/></b-button>
    </b-form>
  </div>
</template>

<script>
import * as tools from '@/tool';
export default {
  name: 'switchMgt',
  data () {
    return {
      form: {
        sysId: 0,
        psWords: '',
        userId: '',
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    wordState() {
      return !tools.isNullOrWhiteSpace(this.form.oldWords)
    },
  },
  methods: {
    onReset(event){
      event.preventDefault();
      this.form.userId = '';
      this.form.psWords = '';
    },
    checkSaveData () {
      let msg = ''

      if (tools.isNullOrWhiteSpace(this.form.userId)) {
        msg = '請輸入帳號'
      } else if (tools.isNullOrWhiteSpace(this.form.psWords)) {
        msg = '請輸入管理員密碼'
      }

      return msg
    },
    onSubmit(event) {
      event.preventDefault();
      var msg = this.checkSaveData()
      if (msg.length === 0) {
        var vm = this;
            this.$http.put('./WebApi/Common/SwitchUserId', this.form)
                      .then((response) => {
                        if (!tools.isNull(response.data) &&
                            (response.data.id == vm.form.userId)) {
                                var usrData = response.data
                                usrData.mode = 'S'
                                vm.$store.dispatch('switchUser')
                                vm.$store.dispatch('actionLogin', usrData)
                                vm.$emit('getDefaultMenu', vm.sysId, false)
                                vm.$router.push({ path: 'main' })
                        } else {
                          tools.showAlert(vm, 'danger', '切換用戶失敗, 請檢查帳號是否輸入正確');
                        }
                      })
                      .catch(function (error) {
                        tools.showAlert(vm, 'danger', '切換用戶失敗'.concat(error));
                      })
      } else {
        tools.showAlert(this, 'danger', '驗證失敗');
        return false
      }
    }
  },
  created () {
    console.log('======created SwitchMgtView =====');
    this.form.sysId = this.sysId;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
